import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    // /sponsorship/list supports: status, restaurantId, id, paymentReference (per documentation)
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SPONSORSHIPS || '/sponsorship/list', {
      queryParams: {
        status: payload?.status || undefined,
        restaurantId: payload?.restaurantId || undefined,
        id: payload?.id || undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch sponsorships',
        data: null,
      }
    }

    // /sponsorship/list returns data: { data: [...], total } per documentation
    const res = raw.data || {}
    const sponsorships = Array.isArray(res) ? res : (Array.isArray(res.data) ? res.data : [])

    const formatted = sponsorships.map(el => ({
      id: el.id,
      storeId: el.restaurantId,
      storeName: el.storeName || el.restaurant?.storeName || el.restaurantName || el.restaurant?.name || el.restaurantId,
      startDate: el.startDate,
      endDate: el.endDate,
      amount: el.amount,
      hasPromotion: el.hasPromotion,
      promotionDetails: el.promotionDetails,
      bannerImageUrl: el.bannerImageUrl,
      status: el.status,
      restaurant: el.restaurant
    }))

    let data = formatted
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? data.length : (res.total || formatted.length),
        result: paginated,
      },
    }
  },
}
